import "./policyPages.scss";

export default function Warranties() {
  return (
    <div className="policyPage">
      <div className="policyPage__text">
        <h2>Warranties</h2>
        <h5>Disclaimer of warranties.</h5>
        <p>The service is provided on an “as is” and “as available” basis.</p>
        <p>
          X-Cloud Solutions expressly disclaims all warranties of any kind,
          whether express or implied, including, but not limited to the implied
          warranties of merchantability, fitness for a particular purpose and
          non-infringement.
        </p>
        <p>X-Cloud Solutions makes no warranty that:</p>
        <p>1. The system will meet user requirements.</p>
        <p>
          2. The system will be uninterrupted, timely, secure, or error-free.
        </p>
        <p>
          3. The results that may be obtained from the use of the system will be
          accurate or reliable.
        </p>
        <p>
          4. The quality of any products, services, information, or other
          material purchased or obtained by user through the system will meet
          user expectation.
        </p>
        <p>5. Any errors in the software will be corrected.</p>
        <p>Limitations of liability</p>
        <p>
          User expressively understand and agree that ict shall not be liable
          for any direct , indirect , incidental, special, consequential damage
          including but not limited to damage for loss of profits , goodwill ,
          use , data or other intangible losses resulting from:
        </p>
        <p>I. The use or the inability to use the system.</p>
        <p>
          II. Authorize access to system or any other matter relating to system.
        </p>
        <p>
          III. The cost of procurement of substitute goods and services
          resulting from any goods, data, information or services purchased or
          obtained or messages received or transactions entered into through or
          from the system
        </p>
        <p>
          IV. Unauthorized access to or alteration of user transmissions or
          data.
        </p>
        <p>V. Statements or conduct of any third party on the system.</p>
        <p>VI. Any other matter relating to the system.</p>
      </div>
      <div className="policyPage__image">
        <img src="/images/warrantiesImage.png" alt="" />
      </div>
    </div>
  );
}
